import { Component, computed, inject, signal } from '@angular/core';
import { PwaInstallService } from '../core/pwa-install.service';

const DISMISS_KEY = 'afs-install-dismissed';

@Component({
  selector: 'app-install-banner',
  standalone: true,
  template: `
    @if (visible()) {
      <div class="install-banner" role="dialog" aria-label="Install app">
        <span>Install AFS Service on this device for quick access.</span>
        <button type="button" class="install" (click)="install()">Install app</button>
        <button type="button" class="dismiss" aria-label="Dismiss" (click)="dismiss()">✕</button>
      </div>
    }
  `,
  styles: [`
    .install-banner {
      display: flex; align-items: center; gap: .75rem;
      padding: .625rem 1rem; background: #0f172a; color: #fff;
    }
    .install-banner span { flex: 1; }
    .install-banner button.install {
      padding: .375rem .875rem; border: 0; border-radius: .375rem;
      background: #38bdf8; color: #0f172a; font-weight: 600;
    }
    .install-banner button.dismiss { background: transparent; border: 0; color: #cbd5e1; font-size: 1.1rem; }
  `],
})
export class InstallBannerComponent {
  private pwa = inject(PwaInstallService);
  private readonly dismissed = signal(sessionStorage.getItem(DISMISS_KEY) === '1');

  readonly visible = computed(() => this.pwa.canInstall() && !this.dismissed());

  install(): void { void this.pwa.promptInstall(); }

  dismiss(): void {
    sessionStorage.setItem(DISMISS_KEY, '1');
    this.dismissed.set(true);
  }
}
